import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { FaCity } from "react-icons/fa";
import { db } from '../../services/firebaseConnection';
import { updateDoc, collection, getDocs, doc } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';



export default function EditCidade() {
  const [nome, setNome] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getCidadeFromDatabase = async () => {
      try {
        const cidadeSnapshot = await getDocs(collection(db, 'Cidade'));
        const cidadeData = cidadeSnapshot.docs.find((doc) => doc.id === id);

        if (cidadeData) {
          setNome(cidadeData.data().nome);
        }
      } catch (error) {
        console.error('Erro ao buscar cidade:', error);
      }
    };

    getCidadeFromDatabase();
  }, [id]);

  async function handleEdit(e) {
    e.preventDefault();

    if (nome !== '') {
      const cidadeDocRef = doc(db, 'Cidade', id);

      await updateDoc(cidadeDocRef, {
        nome: nome,
      })
        .then(() => {
          toast.success('Cidade atualizada!');
          navigate('/cidade');
        })
        .catch((error) => {
          console.log(error);
          toast.error('Erro ao atualizar cidade.');
        });
    } else {
      toast.error('Preencha todos os campos.');
    }
  }

  return (
    <div>
      <Header />

      <div className="content">
        <Title name={nome ? `Editar Cidade - ${nome}` : 'Editar Cidade'} >
          <FaCity size={25} />
        </Title>

        <div className="container">
          <form className="form-profile" onSubmit={handleEdit}>
            <label>Nome</label>
            <input
              type="text"
              placeholder="Nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />

            <button type="submit">Atualizar</button>
          </form>
        </div>
      </div>
    </div>
  );
}
